import {
  FilingType,
  FinanceType,
  LoadingStatusType,
  PP30FormStatus,
  PP30FormTableViewStatusType,
  TaxDocumentType,
  TaxInvoiceType,
  TransactionType,
  TypeComponentNoti,
} from "@/enums/enums";
import {
  ConvertToInsertPP30FormModel,
  ConvertToPP30FormDetailModel,
  ConvertToPP30TransactionFromPeakAccount,
  ConvertToPP30TransactionTableByPeriodTax,
  GetTaxInvoiceTableCountRequest,
  GetTaxInvoiceTableRequest,
  SetHeaderPP30Form,
  SetHeaderPurchasePP30TransactionTable,
  SetHeaderSalesPP30TransactionTable,
  SetTapsPP30Form,
  SetTapsPP30TransactionTable,
  ValidateCreatePP30Transaction,
} from "@/helper/pp30Helper";
import {
  GetMessageExceptionCode,
  GetMessageExceptionCodeForRealtime,
  SetInputErrorByException,
} from "@/helper/shareHelper";
import { MerchantId } from "@/helper/userHelper";
import { i18n } from "@/i18n";
import router from "@/router";
import API from "@/service/Index";
import {
  ConvertToClosingEntryPP30ModelFromMongo,
  ConvertToInsertPP30TransactionModel,
  ConvertToPP30TransactionModel,
  ConvertToPP30TransactionTableAdvanceSearch,
  ConvertToTableDetailPP30FormModel,
  ConvertToTaxInvoiceDetailData,
  ConvertToTaxInvoiceDetailListForTaxPP30,
  ConvertToUpdateIsFiledPP30,
  GetContactIdListForPreparePP30Transaction,
  PrepareInputGetPP30TransactionDetailBySourceData,
  PrepareUpdateCheckingTaxItemDatas,
  SliceArrayData,
} from "@/service/pp30/pp30Facade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import store from "..";

@Module({ namespaced: true })
export default class PP30 extends VuexModule {
  public insertPP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30Transaction: any | null = null;
  public pp30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updatePP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tablePP30Transaction: any = [];
  public headerTablePP30Transaction: any = [];
  public tablePP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tapsPP30TransactionTable: any = [];
  public voidPP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tableCountPP30Transaction: any | null = null;
  public tableCountPP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public tablePP30FormList: any = null;
  public headerTablePP30Form: any = [];
  public tablePP30FormTaps: any = null;
  public tablePP30FormLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public detailPP30FormPeriodYear: any = [];
  public detailPP30FormPeriodYearLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30FormByPeriodTaxList: any = null;
  public pp30FormByPeriodListTaxListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30TransactionTableByPeriodTax: any = null;
  public newPP30FormByPeriodListTaxListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public newPP30FormByPeriodTaxList: any = null;
  public pp30TransactionTableByPeriodTaxLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30TransactionFromPeakAccount: any = null;
  public pp30TransactionFromPeakAccountLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30ByTaxPeriodOnchangeStatus = false;
  public pp30TransactionTableByPeriodTaxForAddNew: any = null;
  public pp30TransactionTableByPeriodTaxForAddNewLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public fetchDataPP30TransactionLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public numberOfFetchDataPP30 = 0;
  public taxInvoiceFetchData: any = null;
  public taxCreditAmount: any = null;
  public taxCreditAmountLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public insertPP30FormLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30FormDetail: any = null;
  public pp30FormDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidPP30FormLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateIsFiledPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public isFiledPP30ModelFromMongoLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public isFiledPP30ModelFromMongoDetail: any = null;
  public updateIsClosingEntryPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateIsPaidPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public closingEntryPP30ModelFromMongo: any = null;
  public closingEntryPP30ModelFromMongoLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public createExpenseByIsClosingEntryPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30FormByLastDateTimeLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30FormByLastDateTimeList: any = null;
  public taxInvoiceDetailListForTaxPP30: any = null;
  public taxInvoiceDetailListForTaxPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public taxInvoiceDetailForUpdateTaxPP30: any = null;
  public taxInvoiceDetailForUpdateTaxPP30LoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public pp30TransactionForDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidIsClosingEntryPP30ExpenseLoadingStatusType: LoadingStatusType = LoadingStatusType.None;
  public voidIsClosingEntryPP30JournalLoadingStatusType: LoadingStatusType = LoadingStatusType.None;
  public voidFileMarkReceiptLoadingStatusType: LoadingStatusType = LoadingStatusType.None;
  public doReceivedTaxInvoiceLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public doPP30TransactionBySourceIdLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public receivedTaxInvoiceData: any = null;
  public pp30TransactionResponse: any = null;
  public pp30TransactionBySourceIdData: any = null;
  public checkingTaxItemDataLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public updateCheckingTaxItemDataLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public countTaxItem: number = 0;
  public countCheckingItem: number = 0;
  public maxTaxItem: number = 0;
  public updateSaleItemSuccess: boolean = false;
  public updatePurchaseItemSuccess: boolean = false;
  public checkingItems: any = null;
  public checkItemSaleSuccess: boolean = false;
  public checkItemPurchaseSuccess: boolean = false;
  public salesTaxUpdateLists: any = null;
  public purchaseTaxUpdateLists: any = null;

  get getSalesTaxUpdateLists(): any {
    return this.salesTaxUpdateLists;
  }
  get getPurchaseTaxUpdateLists(): any {
    return this.purchaseTaxUpdateLists;
  }
  get getCountCheckingItem(): any {
    return this.countCheckingItem;
  }
  get getCheckItemSaleSuccess(): any {
    return this.checkItemSaleSuccess;
  }
  get getCheckItemPurchaseSuccess(): any {
    return this.checkItemPurchaseSuccess;
  }
  get getCheckingItems(): any {
    return this.checkingItems;
  }
  get getCheckingTaxItemDataLoadingStatus(): LoadingStatusType {
    return this.checkingTaxItemDataLoadingStatus;
  }
  get getUpdateCheckingTaxItemDataLoadingStatus(): LoadingStatusType {
    return this.updateCheckingTaxItemDataLoadingStatus;
  }
  get getUpdateSaleItemSuccess(): boolean {
    return this.updateSaleItemSuccess;
  }
  get getUpdatePurchaseItemSuccess(): boolean {
    return this.updatePurchaseItemSuccess;
  }
  get getCountTaxItem(): number {
    return this.countTaxItem;
  }
  get getMaxTaxItem(): number {
    return this.maxTaxItem;
  }
  get getPP30TransactionResponse(): any {
    return this.pp30TransactionResponse;
  }
  get getInsertPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.insertPP30TransactionLoadingStatus;
  }
  get getReceivedTaxInvoiceData(): any {
    return this.receivedTaxInvoiceData;
  }
  get getPP30TransactionBySourceIdData(): any {
    return this.pp30TransactionBySourceIdData;
  }
  get getDoReceivedTaxInvoiceLoadingStatus(): LoadingStatusType {
    return this.doReceivedTaxInvoiceLoadingStatus;
  }
  get getDoPP30TransactionBySourceIdLoadingStatus(): LoadingStatusType {
    return this.doPP30TransactionBySourceIdLoadingStatus;
  }
  get getPP30Transaction(): any {
    return this.pp30Transaction;
  }
  get getPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionLoadingStatus;
  }
  get getUpdatePP30TransactionLoadingStatus(): LoadingStatusType {
    return this.updatePP30TransactionLoadingStatus;
  }
  get getTablePP30Transaction(): any {
    return this.tablePP30Transaction;
  }
  get getHeaderTablePP30Transaction(): any {
    return this.headerTablePP30Transaction;
  }
  get getTablePP30TransactionLoadingStatus(): LoadingStatusType {
    return this.tablePP30TransactionLoadingStatus;
  }
  get getTapsPP30TransactionTable(): any {
    return this.tapsPP30TransactionTable;
  }
  get getVoidPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.voidPP30TransactionLoadingStatus;
  }
  get getTableCountPP30Transaction(): any {
    return this.tableCountPP30Transaction;
  }
  get getTableCountPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.tableCountPP30TransactionLoadingStatus;
  }
  get getTablePP30FormList(): any {
    return this.tablePP30FormList;
  }
  get getHeaderTablePP30Form(): any {
    return this.headerTablePP30Form;
  }
  get getTablePP30FormTaps(): any {
    return this.tablePP30FormTaps;
  }
  get getTablePP30FormLoadingStatus(): LoadingStatusType {
    return this.tablePP30FormLoadingStatus;
  }
  get getDetailPP30FormPeriodYear(): any {
    return this.detailPP30FormPeriodYear;
  }
  get getDetailPP30FormPeriodYearLoadingStatus(): LoadingStatusType {
    return this.detailPP30FormPeriodYearLoadingStatus;
  }
  get getPP30FormByPeriodTaxList(): any {
    return this.pp30FormByPeriodTaxList;
  }
  get getPP30FormByPeriodListTaxListLoadingStatus(): LoadingStatusType {
    return this.pp30FormByPeriodListTaxListLoadingStatus;
  }
  get getNewPP30FormByPeriodListTaxListLoadingStatus(): LoadingStatusType {
    return this.newPP30FormByPeriodListTaxListLoadingStatus;
  }
  get getPP30TransactionTableByPeriodTaxLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionTableByPeriodTaxLoadingStatus;
  }
  get getNewPP30FormByPeriodTaxList(): any {
    return this.newPP30FormByPeriodTaxList;
  }
  get getPP30TransactionTableByPeriodTax(): any {
    return this.pp30TransactionTableByPeriodTax;
  }
  get getPP30TransactionFromPeakAccountLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionFromPeakAccountLoadingStatus;
  }
  get getPP30TransactionFromPeakAccount(): any {
    return this.pp30TransactionFromPeakAccount;
  }
  get getPP30ByTaxPeriodOnchangeStatus(): any {
    return this.pp30ByTaxPeriodOnchangeStatus;
  }
  get getPP30TransactionTableByPeriodTaxForAddNewLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionTableByPeriodTaxForAddNewLoadingStatus;
  }
  get getPP30TransactionTableByPeriodTaxForAddNew(): any {
    return this.pp30TransactionTableByPeriodTaxForAddNew;
  }
  get getFetchDataPP30TransactionLoadingStatus(): LoadingStatusType {
    return this.fetchDataPP30TransactionLoadingStatus;
  }
  get getNumberOfFetchDataPP30(): number {
    return this.numberOfFetchDataPP30;
  }
  get getTaxInvoiceFetchData(): number {
    return this.taxInvoiceFetchData;
  }
  get getTaxCreditAmount(): any {
    return this.taxCreditAmount;
  }
  get getTaxCreditAmountLoadingStatus(): LoadingStatusType {
    return this.taxCreditAmountLoadingStatus;
  }
  get getPP30FormDetail(): any {
    return this.pp30FormDetail;
  }
  get getPP30FormDetailLoadingStatus(): LoadingStatusType {
    return this.pp30FormDetailLoadingStatus;
  }
  get getUpdateIsFiledPP30LoadingStatus(): LoadingStatusType {
    return this.updateIsFiledPP30LoadingStatus;
  }
  get getIsFiledPP30ModelFromMongoLoadingStatus(): LoadingStatusType {
    return this.isFiledPP30ModelFromMongoLoadingStatus;
  }
  get getIsFiledPP30ModelFromMongoDetail(): any {
    return this.isFiledPP30ModelFromMongoDetail;
  }
  get getUpdateIsClosingEntryPP30LoadingStatus(): LoadingStatusType {
    return this.updateIsClosingEntryPP30LoadingStatus;
  }
  get getUpdateIsPaidPP30LoadingStatus(): LoadingStatusType {
    return this.updateIsPaidPP30LoadingStatus;
  }
  get getClosingEntryPP30ModelFromMongo(): any {
    return this.closingEntryPP30ModelFromMongo;
  }
  get getClosingEntryPP30ModelFromMongoLoadingStatus(): LoadingStatusType {
    return this.closingEntryPP30ModelFromMongoLoadingStatus;
  }
  get getCreateExpenseByIsClosingEntryPP30LoadingStatus(): LoadingStatusType {
    return this.createExpenseByIsClosingEntryPP30LoadingStatus;
  }
  get getPP30FormByLastDateTimeList(): any {
    return this.pp30FormByLastDateTimeList;
  }
  get getPP30FormByLastDateTimeLoadingStatus(): LoadingStatusType {
    return this.pp30FormByLastDateTimeLoadingStatus;
  }
  get getTaxInvoiceDetailListForTaxPP30(): any {
    return this.taxInvoiceDetailListForTaxPP30;
  }
  get getTaxInvoiceDetailListForTaxPP30LoadingStatus(): LoadingStatusType {
    return this.taxInvoiceDetailListForTaxPP30LoadingStatus;
  }
  get getTaxInvoiceDetailForUpdateTaxPP30(): any {
    return this.taxInvoiceDetailForUpdateTaxPP30;
  }
  get getTaxInvoiceDetailForUpdateTaxPP30LoadingStatus(): LoadingStatusType {
    return this.taxInvoiceDetailForUpdateTaxPP30LoadingStatus;
  }
  get getPP30TransactionForDetailLoadingStatus(): LoadingStatusType {
    return this.pp30TransactionForDetailLoadingStatus;
  }
  get getVoidIsClosingEntryPP30ExpenseLoadingStatusType(): LoadingStatusType {
    return this.voidIsClosingEntryPP30ExpenseLoadingStatusType;
  }
  get getVoidIsClosingEntryPP30JournalLoadingStatusType(): LoadingStatusType {
    return this.voidIsClosingEntryPP30JournalLoadingStatusType;
  }
  get getVoidFileMarkReceiptLoadingStatusType(): LoadingStatusType {
    return this.voidFileMarkReceiptLoadingStatusType;
  }

  @Mutation
  public SetSalesTaxUpdateLists(items: any) {
    this.salesTaxUpdateLists = items;
  }
  @Mutation
  public SetPurchaseTaxUpdateLists(items: any) {
    this.purchaseTaxUpdateLists = items;
  }
  @Mutation
  public SetCheckItemSaleSuccess(isSuccess: any) {
    this.checkItemSaleSuccess = isSuccess;
  }
  @Mutation
  public SetCheckItemPurchaseSuccess(isSuccess: boolean) {
    this.checkItemPurchaseSuccess = isSuccess;
  }
  @Mutation
  public SetCountCheckingItem(data: any) {
    this.countCheckingItem = data;
  }
  @Mutation
  public SetInsertPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.insertPP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetGetPP30Transaction(pp30Transaction: any) {
    this.pp30Transaction = pp30Transaction;
  }
  @Mutation
  public SetGetPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.pp30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetDoReceivedTaxInvoiceLoadingStatus(status: LoadingStatusType) {
    this.doReceivedTaxInvoiceLoadingStatus = status;
  }
  @Mutation
  public SetDoPP30TransactionBySourceIdLoadingStatus(status: LoadingStatusType) {
    this.doPP30TransactionBySourceIdLoadingStatus = status;
  }
  @Mutation
  public SetReceivedTaxInvoiceData(data: any) {
    this.receivedTaxInvoiceData = data;
  }
  @Mutation
  public SetPP30TransactionBySourceIdData(data: any) {
    this.pp30TransactionBySourceIdData = data;
  }

  @Mutation
  public SetUpdatePP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.updatePP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetGetTablePP30Transaction(pp30Transaction: any) {
    this.tablePP30Transaction = pp30Transaction;
  }
  @Mutation
  public SetHeaderTablePP30Transaction(input: any) {
    if (input.financeType === FinanceType.InFlow) {
      this.headerTablePP30Transaction = SetHeaderSalesPP30TransactionTable();
    } else {
      this.headerTablePP30Transaction = SetHeaderPurchasePP30TransactionTable();
    }

    if (input.sorting !== null) {
      this.headerTablePP30Transaction.forEach((item: any) => {
        if (item.sortBy == input.sortBy) {
          item.sortingType = input.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }
  @Mutation
  public SetGetTablePP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.tablePP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetVoidPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.voidPP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetGetTableCountPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.tableCountPP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetGetTableCountPP30Transaction(table: any) {
    this.tableCountPP30Transaction = table.tableCountPP30Transaction;
    this.tapsPP30TransactionTable = SetTapsPP30TransactionTable(table.tableView, table.pp30TransactionCount);
  }
  @Mutation
  public SetTablePP30FormLoadingStatus(status: LoadingStatusType) {
    this.tablePP30FormLoadingStatus = status;
  }
  @Mutation
  public SetPP30FormPeriodYear(input: any) {
    this.detailPP30FormPeriodYear = input;
  }
  @Mutation
  public SetPP30FormPeriodYearLoadingStatus(status: LoadingStatusType) {
    this.detailPP30FormPeriodYearLoadingStatus = status;
  }
  @Mutation
  public SetTablePP30Form(input: any) {
    this.tablePP30FormTaps = SetTapsPP30Form(input.tableView, input.data.countTable);
    this.tablePP30FormList = input.data.tableDetailPP30FormList;
  }
  @Mutation
  public SetTablePP30FormAdvanceSearch(input: any) {
    this.tablePP30FormTaps = SetTapsPP30Form(input.tableView, input.countTable);
    this.tablePP30FormList = input.tableDetailPP30FormList;
  }
  @Mutation
  public SetHeaderTablePP30Form(input: any) {
    this.headerTablePP30Form = SetHeaderPP30Form();

    if (input.sorting !== null) {
      this.headerTablePP30Form.forEach((item: any) => {
        if (item.sortBy == input.sortBy) {
          item.sortingType = input.sortingType;
        } else {
          item.sortingType = null;
        }
      });
    }
  }
  @Mutation
  public SetPP30FormByPeriodTaxList(pp30FormByPeriodTaxList: any) {
    this.pp30FormByPeriodTaxList = pp30FormByPeriodTaxList;
  }
  @Mutation
  public SetPP30FormByPeriodTaxListLoadingStatus(status: any) {
    this.pp30FormByPeriodListTaxListLoadingStatus = status;
  }
  @Mutation
  public SetNewPP30FormByPeriodTaxListLoadingStatus(status: any) {
    this.newPP30FormByPeriodListTaxListLoadingStatus = status;
  }
  @Mutation
  public SetCheckingTaxItemDataLoadingStatus(status: LoadingStatusType) {
    this.checkingTaxItemDataLoadingStatus = status;
  }
  @Mutation
  public SetCheckingItems(status: LoadingStatusType) {
    this.checkingItems = status;
  }
  @Mutation
  public SetUpdateCheckingTaxItemDataLoadingStatus(status: LoadingStatusType) {
    this.updateCheckingTaxItemDataLoadingStatus = status;
  }
  @Mutation
  public SetCountTaxItem(data: any) {
    this.countTaxItem = data;
  }
  @Mutation
  public SetMaxTaxItem(data: any) {
    this.maxTaxItem = data;
  }
  @Mutation
  public SetUpdateSaleItemSuccess(updateSaleItemSuccess: any) {
    this.updateSaleItemSuccess = updateSaleItemSuccess;
  }
  @Mutation
  public SetUpdatePurchaseItemSuccess(updatePurchaseItemSuccess: any) {
    this.updatePurchaseItemSuccess = updatePurchaseItemSuccess;
  }
  @Mutation
  public SetNewPP30FormByPeriodTaxList(pp30FormByPeriodTaxList: any) {
    this.newPP30FormByPeriodTaxList = pp30FormByPeriodTaxList;
  }

  @Mutation SetPP30TransactionTableByPeriodTaxLoadingStatus(status: any) {
    this.pp30TransactionTableByPeriodTaxLoadingStatus = status;
  }

  @Mutation SetPP30TransactionTableByPeriodTax(pp30TransactionTableByPeriodTax: any) {
    this.pp30TransactionTableByPeriodTax = pp30TransactionTableByPeriodTax;
  }

  @Mutation SetPP30TransactionFromPeakAccountLoadingStatus(status: any) {
    this.pp30TransactionFromPeakAccountLoadingStatus = status;
  }

  @Mutation SetPP30TransactionResponse(response: any) {
    this.pp30TransactionResponse = response;
  }

  @Mutation SetPP30TransactionFromPeakAccount(pp30TransactionFromPeakAccount: any) {
    this.pp30TransactionFromPeakAccount = pp30TransactionFromPeakAccount;
  }

  @Mutation
  public SetPP30TransactionTableByPeriodTaxForAddNewLoadingStatus(status: LoadingStatusType) {
    this.pp30TransactionTableByPeriodTaxForAddNewLoadingStatus = status;
  }
  @Mutation
  public SetPP30TransactionTableByPeriodTaxForAddNew(pp30TransactionTableByPeriodTax: any) {
    this.pp30TransactionTableByPeriodTaxForAddNew = pp30TransactionTableByPeriodTax;
  }
  @Mutation
  public SetPP30ByTaxPeriodOnchangeStatus(status: boolean) {
    this.pp30ByTaxPeriodOnchangeStatus = status;
  }
  @Mutation
  public SetFetchDataPP30TransactionLoadingStatus(status: LoadingStatusType) {
    this.fetchDataPP30TransactionLoadingStatus = status;
  }
  @Mutation
  public SetNumberOfFetchDataPP30(number: number) {
    this.numberOfFetchDataPP30 = number;
  }
  @Mutation
  public SetTaxInvoiceFetchData(data: any) {
    this.taxInvoiceFetchData = data;
  }
  @Mutation
  public SetTaxCreditAmount(pp30FormByPeriodTaxList: any) {
    this.taxCreditAmount = 0;
    pp30FormByPeriodTaxList.forEach((pp30FormByPeriodTax: any) => {
      if (pp30FormByPeriodTax.filingType == FilingType.Normal) {
        this.taxCreditAmount = pp30FormByPeriodTax.remainingTaxCreditAmount;
      }
    });
  }
  @Mutation
  public SetTaxCreditAmountListLoadingStatus(status: LoadingStatusType) {
    this.taxCreditAmountLoadingStatus = status;
  }
  @Mutation
  public SetInsertPP30FormLoadingStatusLoadingStatus(status: LoadingStatusType) {
    this.insertPP30FormLoadingStatus = status;
  }
  @Mutation
  public SetPP30FormDetai(pp30FormDetailModel: any) {
    this.pp30FormDetail = pp30FormDetailModel;
  }
  @Mutation
  public SetPP30FormDetailLoadingStatus(status: LoadingStatusType) {
    this.pp30FormDetailLoadingStatus = status;
  }
  @Mutation
  public SetPP30TransactionForDetailLoadingStatus(status: LoadingStatusType) {
    this.pp30TransactionForDetailLoadingStatus = status;
  }
  @Mutation
  public SetVoidPP30FormLoadingStatus(status: LoadingStatusType) {
    this.voidPP30FormLoadingStatus = status;
  }
  @Mutation
  public SetUpdateIsFiledPP30LoadingStatus(status: LoadingStatusType) {
    this.updateIsFiledPP30LoadingStatus = status;
  }
  @Mutation
  public SetIsFiledPP30ModelFromMongoLoadingStatus(status: LoadingStatusType) {
    this.isFiledPP30ModelFromMongoLoadingStatus = status;
  }
  @Mutation
  public SetIsFiledPP30ModelFromMongoDetail(IsFiledPP30Model: any) {
    this.isFiledPP30ModelFromMongoDetail = IsFiledPP30Model;
  }
  @Mutation
  public SetUpdateIsClosingEntryPP30LoadingStatus(status: LoadingStatusType) {
    this.updateIsClosingEntryPP30LoadingStatus = status;
  }

  @Mutation
  public SetUpdateIsPaidPP30LoadingStatus(status: LoadingStatusType) {
    this.updateIsPaidPP30LoadingStatus = status;
  }

  @Mutation
  public SetClosingEntryPP30ModelFromMongo(_closingEntryPP30ModelFromMongo: any) {
    this.closingEntryPP30ModelFromMongo = _closingEntryPP30ModelFromMongo;
  }

  @Mutation
  public SetClosingEntryPP30ModelFromMongoLoadingStatus(status: LoadingStatusType) {
    this.closingEntryPP30ModelFromMongoLoadingStatus = status;
  }

  @Mutation
  public SetCreateExpenseByIsClosingEntryPP30LoadingStatus(status: LoadingStatusType) {
    this.createExpenseByIsClosingEntryPP30LoadingStatus = status;
  }
  @Mutation
  public SetPP30FormByLastDateTimeLoadingStatus(status: LoadingStatusType) {
    this.pp30FormByLastDateTimeLoadingStatus = status;
  }

  @Mutation
  public SetPP30FormByLastDateTimeList(pp30FormByLastDateTimeInput: any): any {
    if (pp30FormByLastDateTimeInput && pp30FormByLastDateTimeInput.length > 0) {
      this.pp30FormByLastDateTimeList = pp30FormByLastDateTimeInput[0];
    } else {
      this.pp30FormByLastDateTimeList = null;
    }
  }

  @Mutation
  public SetTaxInvoiceDetailListForTaxPP30(taxInvoiceDetailListForTaxPP30: any) {
    this.taxInvoiceDetailListForTaxPP30 = taxInvoiceDetailListForTaxPP30;
  }

  @Mutation
  public SetTaxInvoiceDetailListForTaxPP30LoadingStatus(status: LoadingStatusType) {
    this.taxInvoiceDetailListForTaxPP30LoadingStatus = status;
  }

  @Mutation
  public SetVoidIsClosingEntryPP30ExpenseLoadingStatusType(status: LoadingStatusType) {
    this.voidIsClosingEntryPP30ExpenseLoadingStatusType = status;
  }

  @Mutation
  public SetVoidIsClosingEntryPP30JournalLoadingStatusType(status: LoadingStatusType) {
    this.voidIsClosingEntryPP30JournalLoadingStatusType = status;
  }

  @Mutation
  public SetVoidFileMarkReceiptLoadingStatusType(status: LoadingStatusType) {
    this.voidFileMarkReceiptLoadingStatusType = status;
  }

  @Mutation
  public SetTaxInvoiceDetailForUpdateTaxPP30(taxInvoiceDetailForUpdateTaxPP30: any) {
    this.taxInvoiceDetailForUpdateTaxPP30 = taxInvoiceDetailForUpdateTaxPP30;
  }

  @Mutation
  public SetTaxInvoiceDetailForUpdateTaxPP30LoadingStatus(status: LoadingStatusType) {
    this.taxInvoiceDetailForUpdateTaxPP30LoadingStatus = status;
  }

  @Action
  public DoInsertPP30Transaction(input: any) {
    const validated = ValidateCreatePP30Transaction(input.pp30TransactionTemplate);
    if (validated) {
      const pp30TransactionModel = ConvertToInsertPP30TransactionModel(input.pp30TransactionTemplate);
      if (this.insertPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
        this.context.commit("SetInsertPP30TransactionLoadingStatus", LoadingStatusType.Loading);
        API.PP30Service.InsertPP30Transaction(pp30TransactionModel).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            let linkName = "";
            let alertMessage = "";
            switch (input.pp30TransactionTemplate.financeType) {
              case FinanceType.InFlow:
                linkName = "salesTaxItemDetail";
                alertMessage = "Create_Sales_Tax_Item_Success";
                break;
              case FinanceType.OutFlow:
                linkName = "purchaseTaxItemDetail";
                alertMessage = "Create_Purchase_Tax_Item_Success";
                break;
            }
            if (input.isRedirect) {
              router.push({
                name: linkName,
                query: { emi: MerchantId().PeakEncryption(), eti: btoa(res.data.data.id.toString()) },
              });
            }

            store.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t(alertMessage, { msg: res.data.data.taxInvoiceNumber }),
                typeMessage: TypeComponentNoti.success,
              },
              { root: true }
            );
            this.context.commit("SetInsertPP30TransactionLoadingStatus", LoadingStatusType.Success);
          } else {
            const alertMessage = GetMessageExceptionCode(res.data.exception);
            SetInputErrorByException(input.pp30TransactionTemplate, res.data.exception);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: alertMessage,
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
            this.context.commit("SetInsertPP30TransactionLoadingStatus", LoadingStatusType.None);
          }
        });
      }
    } else {
      this.context.dispatch(
        "Alert/SetAlertMessage",
        {
          alertMessage: i18n.t("AlertNoti_Create_Input_Error"),
          typeMessage: TypeComponentNoti.error,
        },
        { root: true }
      );
    }
  }

  @Action
  public DoGetPP30Transaction(transactionId: number) {
    if (this.pp30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PP30Service.GetPP30Transaction(transactionId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const pp30TransactionTemplate = ConvertToPP30TransactionModel(res.data.data);
          this.context.commit("SetGetPP30Transaction", pp30TransactionTemplate);
          this.context.commit("SetGetPP30TransactionLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        } else {
          this.context.commit("SetPP30TransactionResponse", res.data.responseCode);
          this.context.commit("SetGetPP30TransactionLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoUpdatePP30Transaction(pp30TransactionTemplate: any) {
    const pp30TransactionModel = ConvertToInsertPP30TransactionModel(pp30TransactionTemplate);
    if (this.updatePP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdatePP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdatePP30Transaction(pp30TransactionModel).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          store.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(
                pp30TransactionTemplate.financeType === FinanceType.InFlow
                  ? "Update_Sales_Tax_Item_Success"
                  : "Update_Purchase_Tax_Item_Success",
                { msg: res.data.data.taxInvoiceNumber }
              ),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
          this.context.commit("SetUpdatePP30TransactionLoadingStatus", LoadingStatusType.Success);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          SetInputErrorByException(pp30TransactionTemplate, res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
          this.context.commit("SetUpdatePP30TransactionLoadingStatus", LoadingStatusType.None);
        }
      });
    }
  }

  @Action
  public DoVoidPP30Transaction(input: any) {
    if (this.voidPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetVoidPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.VoidPP30Transaction(input.transactionId).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          let alertMessage = "";
          switch (input.financeType) {
            case FinanceType.InFlow:
              alertMessage = "Delete_Sales_Tax_Item_Success";
              break;
            case FinanceType.OutFlow:
              alertMessage = "Delete_Purchase_Tax_Item_Success";
              break;
          }
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t(alertMessage, { msg: res.data.data.taxInvoiceNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidPP30TransactionLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoGetTablePP30TransactionAdvanceSearchDefault(input: any) {
    if (this.tablePP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTablePP30TransactionAdvanceSearchDefault(input).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactIdList = GetContactIdListForPreparePP30Transaction(res.data.data);
          const headerTablePP30Transaction = {
            financeType: input.financeType,
            sortBy: input.transactionTableSortColumnType,
            sortingType: input.tableSortType,
          };
          if (contactIdList.length > 0) {
            await store.dispatch("Contact/DoGetContactByContactIdList", contactIdList, {
              root: true,
            });
          }
          const contactList = store.getters["Contact/getContactModelList"];
          const tablePP30Transaction = ConvertToPP30TransactionTableAdvanceSearch(res.data.data, contactList);
          this.context.commit("SetGetTablePP30Transaction", tablePP30Transaction);
          this.context.commit("SetHeaderTablePP30Transaction", headerTablePP30Transaction);
        }
        this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetTablePP30TransactionAdvanceSearch(input: any) {
    if (this.tablePP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTablePP30TransactionAdvanceSearch(input).then(async (res) => {
        if (res.data.responseCode.IsSuccess()) {
          const contactIdList = GetContactIdListForPreparePP30Transaction(res.data.data);
          const headerTablePP30Transaction = {
            financeType: input.financeType,
            sortBy: input.transactionTableSortColumnType,
            sortingType: input.tableSortType,
          };
          if (contactIdList.length > 0) {
            await store.dispatch("Contact/DoGetContactByContactIdList", contactIdList, {
              root: true,
            });
          }
          const contactList = store.getters["Contact/getContactModelList"];
          const tablePP30Transaction = ConvertToPP30TransactionTableAdvanceSearch(res.data.data, contactList);
          this.context.commit("SetGetTablePP30Transaction", tablePP30Transaction);
          this.context.commit("SetHeaderTablePP30Transaction", headerTablePP30Transaction);
        }
        this.context.commit("SetGetTablePP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetTableCountPP30TransactionAdvanceSearch(input: any) {
    if (this.tableCountPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetGetTableCountPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTableCountPP30TransactionAdvanceSearch(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tableCountPP30Transaction = {
            pp30TransactionCount: res.data.data,
            tableView: input.transactionTableViewStatusType,
          };
          this.context.commit("SetGetTableCountPP30Transaction", tableCountPP30Transaction);
        }
        this.context.commit("SetGetTableCountPP30TransactionLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetTablePP30Form(input: any) {
    if (this.tablePP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTablePP30FormLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetTablePP30Form(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tablePP30Form = {
            data: res.data.data,
            tableView: input.transactionTableViewStatusType,
          };
          const headerTablePP30Form = {
            sortBy: input.pp30FormTableSortColumnType,
            sortingType: input.tableSortType,
          };
          this.context.commit("SetTablePP30Form", tablePP30Form);
          this.context.commit("SetHeaderTablePP30Form", headerTablePP30Form);
        }
        this.context.commit("SetTablePP30FormLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetPP30FormPeriodYear(input: any) {
    if (this.detailPP30FormPeriodYearLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetPP30FormPeriodYearLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormPeriodYear(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetPP30FormPeriodYear", res.data.data);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetPP30FormPeriodYearLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetPP30FormTableAdvanceSearch(input: any) {
    if (this.tablePP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTablePP30FormLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormTableAdvanceSearch(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const tablePP30Form = {
            tableDetailPP30FormList: ConvertToTableDetailPP30FormModel(res.data.data.tableDetailPP30FormList),
            countTable: res.data.data.countTable,
            tableView: input.transactionTableViewStatusType,
          };
          const headerTablePP30Form = {
            sortBy: input.pp30FormTableSortColumnType,
            sortingType: input.tableSortType,
          };
          this.context.commit("SetTablePP30FormAdvanceSearch", tablePP30Form);
          this.context.commit("SetHeaderTablePP30Form", headerTablePP30Form);
        }
        this.context.commit("SetTablePP30FormLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoGetPP30FormByPeriodTax(input: any) {
    if (this.pp30FormByPeriodListTaxListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30FormByPeriodTaxListLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetPP30FormByPeriodTaxList", res.data.data);
        }
        this.context.commit("SetPP30FormByPeriodTaxListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoNewGetPP30FormByPeriodTax(input: any) {
    if (this.newPP30FormByPeriodListTaxListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetNewPP30FormByPeriodTaxListLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetNewPP30FormByPeriodTaxList", res.data.data);
        }
        this.context.commit("SetNewPP30FormByPeriodTaxListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public async DoGetCheckingTaxItemData(input: any) {
    if (this.checkingTaxItemDataLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCountCheckingItem", 0);
      this.context.commit("SetCheckingTaxItemDataLoadingStatus", LoadingStatusType.Loading);
      let isSuccess = false;
      await API.PP30Service.GetCheckingTaxItemData(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          isSuccess = true;
          this.context.commit("SetCheckingItems", res.data.data);
        } else {
          isSuccess = false;
        }
      });
      if (isSuccess) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await this.context.commit("SetCheckItemSaleSuccess", true);
        await this.context.commit("SetCountCheckingItem", 1);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await this.context.commit("SetCheckItemPurchaseSuccess", true);
        await this.context.commit("SetCountCheckingItem", 2);
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await this.context.commit("SetCheckingTaxItemDataLoadingStatus", LoadingStatusType.Success);
      } else {
        this.context.commit("SetCheckingTaxItemDataLoadingStatus", LoadingStatusType.Fail);
      }
    }
  }

  @Action
  public async DoUpdateCheckingTaxItemData(input: any) {
    if (this.updateCheckingTaxItemDataLoadingStatus !== LoadingStatusType.Loading) {
      const maxSliceArray = 1000;
      this.context.commit("SetUpdateCheckingTaxItemDataLoadingStatus", LoadingStatusType.Loading);
      let countTotal = 0;
      this.context.commit("SetMaxTaxItem", input.data.totalCount);
      if (input.data.saleIdList && input.data.saleIdList.length > 0) {
        const saleDataArray = SliceArrayData(input.data.saleIdList, maxSliceArray);
        for (let count = 0; count < saleDataArray.length; count++) {
          const saleInput = PrepareUpdateCheckingTaxItemDatas(
            FinanceType.InFlow,
            input.periodDate,
            saleDataArray[count],
            countTotal
          );

          await API.PP30Service.UpdateCheckingTaxItemData(saleInput).then((res) => {
            this.context.commit("SetSalesTaxUpdateLists", res.data.data);
          });
          for (let c = 0; c < saleDataArray[count].length; c++) {
            countTotal = countTotal + 1;
            await new Promise((resolve) => setTimeout(resolve, 100));
            this.context.commit("SetCountTaxItem", countTotal);
          }
        }
        const lastId = input.data.saleIdList[input.data.saleIdList.length - 1];
        const inputData = PrepareInputGetPP30TransactionDetailBySourceData(FinanceType.InFlow, lastId);
        for (let count = 0; count < 1; ) {
          await new Promise((resolve) => setTimeout(resolve, 2000));
          await API.PP30Service.DoGetPP30TransactionDetailBySourceId(inputData).then((res) => {
            if (res.data.responseCode.IsSuccess() && res.data.data && res.data.data.length > 0) {
              this.context.commit("SetUpdateSaleItemSuccess", true);
              count = 1;
            }
          });
        }
      }
      if (input.data.purchaseIdList && input.data.purchaseIdList.length > 0) {
        const purchaseDataArray = SliceArrayData(input.data.purchaseIdList, maxSliceArray);
        for (let count = 0; count < purchaseDataArray.length; count++) {
          const purchaseInput = PrepareUpdateCheckingTaxItemDatas(
            FinanceType.InFlow,
            input.periodDate,
            purchaseDataArray[count],
            countTotal
          );
          setTimeout(() => {
            this.context.commit("SetCountTaxItem", countTotal);
          }, 500);
          await API.PP30Service.UpdateCheckingTaxItemData(purchaseInput).then((res) => {
            this.context.commit("SetPurchaseTaxUpdateLists", res.data.data);
          });
          for (let c = 0; c < purchaseDataArray[count].length; c++) {
            countTotal = countTotal + 1;
            await new Promise((resolve) => setTimeout(resolve, 100));
            this.context.commit("SetCountTaxItem", countTotal);
          }
        }
        const lastId = input.data.purchaseIdList[input.data.purchaseIdList.length - 1];
        const inputData = PrepareInputGetPP30TransactionDetailBySourceData(FinanceType.OutFlow, lastId);
        for (let count = 0; count < 1; ) {
          await new Promise((resolve) => setTimeout(resolve, 5000));
          await API.PP30Service.DoGetPP30TransactionDetailBySourceId(inputData).then((res) => {
            if (res.data.responseCode.IsSuccess() && res.data.data) {
              this.context.commit("SetUpdatePurchaseItemSuccess", true);
              count = 1;
            }
          });
        }
      }
      setTimeout(() => {
        this.context.commit("SetUpdateCheckingTaxItemDataLoadingStatus", LoadingStatusType.Success);
      }, 1000);
    }
  }

  @Action
  public DoGetChangeTaxCreditAmount(input: any) {
    if (this.taxCreditAmountLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTaxCreditAmountListLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetTaxCreditAmount", res.data.data);
        }
        this.context.commit("SetTaxCreditAmountListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  // async checkLoop() {
  //   const count = 0;
  //   while (count == 1) {
  //     await new Promise((resolve) => setTimeout(resolve, 100)); // หยุดรอ 100ms เพื่อให้ CPU ได้พัก
  //     // ทำการเช็คค่าที่นี่
  //   }
  // }

  @Action
  public DoGetPP30TransactionTableByPeriodTax(input: any) {
    if (this.pp30TransactionTableByPeriodTaxLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30TransactionTableByPeriodTaxLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30TransactionTableByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const pp30TransactionTableByPeriodTax = ConvertToPP30TransactionTableByPeriodTax(res.data.data, input.check);
          this.context.commit("SetPP30TransactionTableByPeriodTax", pp30TransactionTableByPeriodTax);
        }
        this.context.commit("SetPP30TransactionTableByPeriodTaxLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoGetPP30TransactionFromPeakAccount(input: any) {
    if (this.pp30TransactionFromPeakAccountLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30TransactionFromPeakAccountLoadingStatus", LoadingStatusType.Loading);
      const _inputCount = GetTaxInvoiceTableCountRequest(input);
      API.PP30Service.DoGetPurchaseTaxInvoiceTableCount(_inputCount).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.tableCount > 0) {
            const _inputTable = GetTaxInvoiceTableRequest(input, res.data.tableCount);
            API.PP30Service.DoGetPurchaseTaxInvoiceTable(_inputTable).then((resTable) => {
              if (resTable.data.responseCode.IsSuccess()) {
                const pp30Transaction = ConvertToPP30TransactionFromPeakAccount(resTable.data.table);
                this.context.commit("SetPP30TransactionFromPeakAccount", pp30Transaction);
                this.context.commit("SetPP30TransactionFromPeakAccountLoadingStatus", LoadingStatusType.Success);
              }
            });
          } else {
            this.context.commit("SetPP30TransactionFromPeakAccountLoadingStatus", LoadingStatusType.Success);
          }
        }
      });
    }
  }

  @Action
  public DoCreateReceivedTaxInvoice(input: any) {
    if (this.doReceivedTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoGetPurchaseInventoryDetail(input.transactionId).then((resDetail) => {
        if (resDetail.status.IsSuccess()) {
          const fromCurrency = resDetail.data.invoice.fromCurrency;
          const receivedTaxInvoice = {
            netAmount: fromCurrency.netTotal - fromCurrency.vatExemptedTotal,
            preVatTotal: fromCurrency.preVatTotal,
            receivedTaxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
            receivedTaxInvoiceNumber: input.receivedTaxInvoice.receivedTaxInvoiceNumber,
            receivedTaxInvoiceJournalDate: input.receivedTaxInvoice.receivedTaxInvoiceJournalDate,
            vatTotal: input.receivedTaxInvoice.vatTotal,
            purchaseTaxPeriodDate: input.receivedTaxInvoice.taxPeriod,
          };
          API.PP30Service.DoCreateReceivedTaxInvoice(input, receivedTaxInvoice).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const sourceIdInput = {
                financeType: input.financeType,
                sourceId: input.sourceId,
                sourceType: input.sourceType,
                taxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
                taxInvoiceType: TaxInvoiceType.TaxInvoice,
                taxPeriod: input.receivedTaxInvoice.taxPeriod,
              };
              this.context.commit("SetReceivedTaxInvoiceData", sourceIdInput);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
            } else {
              const alertMessage = GetMessageExceptionCodeForRealtime(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
            }
          });
        } else {
          this.context.dispatch("Loading/IsLoading", false, { root: true });
          this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
        }
      });
    }
  }

  @Action
  public DoGetPP30TransactionBySourceId(input: any) {
    if (this.doPP30TransactionBySourceIdLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetDoPP30TransactionBySourceIdLoadingStatus", LoadingStatusType.Loading);
      let intervalId: any;
      let count = 0;
      const sourceIdInput = {
        merchantId: MerchantId(),
        financeType: input.financeType,
        sourceId: input.sourceId,
        sourceType: input.sourceType,
      };
      const frame = () => {
        if (count == 10) {
          this.context.dispatch("Loading/IsLoading", false, { root: true });
          this.context.commit("SetDoPP30TransactionBySourceIdLoadingStatus", LoadingStatusType.Success);
          clearInterval(intervalId);
          intervalId = null;
        } else {
          API.PP30Service.GetPP30TransactionBySourceId(sourceIdInput).then((resSourceId) => {
            if (resSourceId.data.responseCode.IsSuccess()) {
              if (resSourceId.data.data && resSourceId.data.data.length > 0) {
                const data = {
                  id: resSourceId.data.data[0].taxInvoiceId,
                  taxInvoiceDate: input.taxInvoiceDate,
                  taxInvoiceNumber: resSourceId.data.data[0].taxInvoiceNumber,
                  taxInvoiceType: input.taxInvoiceType,
                  taxPeriod: input.taxPeriod,
                  sourceId: input.sourceId,
                };
                this.context.commit("SetPP30TransactionBySourceIdData", data);
                this.context.commit("SetDoPP30TransactionBySourceIdLoadingStatus", LoadingStatusType.Success);
                this.context.dispatch("Loading/IsLoading", false, { root: true });
                clearInterval(intervalId);
                intervalId = null;
              } else {
                count++;
              }
            } else {
              this.context.commit("SetPP30TransactionBySourceIdData", null);
              this.context.commit("SetDoPP30TransactionBySourceIdLoadingStatus", LoadingStatusType.Fail);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            }
          });
        }
      };

      intervalId = setInterval(frame, 1000);
    }
  }

  @Action
  public DoCreateReceivedTaxInvoiceForDeposit(input: any) {
    if (this.doReceivedTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoGetReceivedDepositDetail(input.transactionId).then((resDetail) => {
        if (resDetail.status.IsSuccess()) {
          const fromCurrency = resDetail.data.detail.fromCurrency;
          const receivedTaxInvoice = {
            netAmount: fromCurrency.netTotal - fromCurrency.vatExemptedTotal,
            preVatTotal: fromCurrency.preVatTotal,
            receivedTaxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
            receivedTaxInvoiceNumber: input.receivedTaxInvoice.receivedTaxInvoiceNumber,
            receivedTaxInvoiceJournalDate: input.receivedTaxInvoice.receivedTaxInvoiceJournalDate,
            vatTotal: input.receivedTaxInvoice.vatTotal,
            purchaseTaxPeriodDate: input.receivedTaxInvoice.taxPeriod,
          };
          API.PP30Service.DoCreateReceivedTaxInvoice(input, receivedTaxInvoice).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const sourceIdInput = {
                financeType: input.financeType,
                sourceId: input.sourceId,
                sourceType: input.sourceType,
                taxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
                taxPeriod: input.receivedTaxInvoice.taxPeriod,
                taxInvoiceType: TaxInvoiceType.TaxInvoice,
              };
              this.context.commit("SetReceivedTaxInvoiceData", sourceIdInput);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
            } else {
              const alertMessage = GetMessageExceptionCodeForRealtime(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
            }
          });
        } else {
          this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoCreateReceivedTaxInvoiceForCreditNote(input: any) {
    if (this.doReceivedTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoGetPurchaseCreditNoteDetail(input.transactionId).then((resDetail) => {
        if (resDetail.status.IsSuccess()) {
          const fromCurrency = resDetail.data.detail.transactionCurrency;
          const receivedTaxInvoice = {
            netAmount: fromCurrency.currencyNetAmount - fromCurrency.currencyVatExemptedTotal,
            preVatTotal: fromCurrency.currencyPreVatTotal,
            receivedTaxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
            receivedTaxInvoiceNumber: input.receivedTaxInvoice.receivedTaxInvoiceNumber,
            receivedTaxInvoiceJournalDate: input.receivedTaxInvoice.receivedTaxInvoiceJournalDate,
            vatTotal: input.receivedTaxInvoice.vatTotal,
            purchaseTaxPeriodDate: input.receivedTaxInvoice.taxPeriod,
          };
          API.PP30Service.DoCreateReceivedTaxInvoice(input, receivedTaxInvoice).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const sourceIdInput = {
                financeType: input.financeType,
                sourceId: input.sourceId,
                sourceType: input.sourceType,
                taxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
                taxPeriod: input.receivedTaxInvoice.taxPeriod,
                taxInvoiceType: TaxInvoiceType.CreditNote,
              };
              this.context.commit("SetReceivedTaxInvoiceData", sourceIdInput);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
            } else {
              const alertMessage = GetMessageExceptionCodeForRealtime(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
            }
          });
        } else {
          this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoCreateReceivedTaxInvoiceForDebitNote(input: any) {
    if (this.doReceivedTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoGetPurchaseDebitNoteDetail(input.transactionId).then((resDetail) => {
        if (resDetail.status.IsSuccess()) {
          const fromCurrency = resDetail.data.debitNote.transactionCurrency;
          const receivedTaxInvoice = {
            netAmount: fromCurrency.currencyNetAmount - fromCurrency.currencyVatExemptedTotal,
            preVatTotal: fromCurrency.currencyPreVatTotal,
            receivedTaxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
            receivedTaxInvoiceNumber: input.receivedTaxInvoice.receivedTaxInvoiceNumber,
            receivedTaxInvoiceJournalDate: input.receivedTaxInvoice.receivedTaxInvoiceJournalDate,
            vatTotal: input.receivedTaxInvoice.vatTotal,
            purchaseTaxPeriodDate: input.receivedTaxInvoice.taxPeriod,
          };
          API.PP30Service.DoCreateReceivedTaxInvoice(input, receivedTaxInvoice).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const sourceIdInput = {
                financeType: input.financeType,
                sourceId: input.sourceId,
                sourceType: input.sourceType,
                taxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
                taxPeriod: input.receivedTaxInvoice.taxPeriod,
                taxInvoiceType: TaxInvoiceType.DebitNote,
              };
              this.context.commit("SetReceivedTaxInvoiceData", sourceIdInput);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
            } else {
              const alertMessage = GetMessageExceptionCodeForRealtime(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
            }
          });
        } else {
          this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoCreateReceivedTaxInvoiceForInvoiceReceipt(input: any) {
    if (this.doReceivedTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoGetInvoiceReceiptDetail(input.transactionId).then((resDetail) => {
        if (resDetail.status.IsSuccess()) {
          const fromCurrency = resDetail.data.detail.fromCurrency;
          const receivedTaxInvoice = {
            netAmount: fromCurrency.netTotal - fromCurrency.vatExemptedTotal,
            preVatTotal: fromCurrency.preVatTotal,
            receivedTaxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
            receivedTaxInvoiceNumber: input.receivedTaxInvoice.receivedTaxInvoiceNumber,
            receivedTaxInvoiceJournalDate: input.receivedTaxInvoice.receivedTaxInvoiceJournalDate,
            vatTotal: input.receivedTaxInvoice.vatTotal,
            purchaseTaxPeriodDate: input.receivedTaxInvoice.taxPeriod,
          };
          API.PP30Service.DoCreateReceivedTaxInvoice(input, receivedTaxInvoice).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const sourceIdInput = {
                financeType: input.financeType,
                sourceId: input.sourceId,
                sourceType: input.sourceType,
                taxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
                taxPeriod: input.receivedTaxInvoice.taxPeriod,
                taxInvoiceType: TaxInvoiceType.TaxInvoice,
              };
              this.context.commit("SetReceivedTaxInvoiceData", sourceIdInput);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
            } else {
              const alertMessage = GetMessageExceptionCodeForRealtime(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
            }
          });
        } else {
          this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoCreateReceivedTaxInvoiceForAsset(input: any) {
    if (this.doReceivedTaxInvoiceLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoGetPurchaseAssetDetail(input.transactionId).then((resDetail) => {
        if (resDetail.status.IsSuccess()) {
          const fromCurrency = resDetail.data.detail.fromCurrency;
          const receivedTaxInvoice = {
            netAmount: fromCurrency.netTotal - fromCurrency.vatExemptedTotal,
            preVatTotal: fromCurrency.preVatTotal,
            receivedTaxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
            receivedTaxInvoiceNumber: input.receivedTaxInvoice.receivedTaxInvoiceNumber,
            receivedTaxInvoiceJournalDate: input.receivedTaxInvoice.receivedTaxInvoiceJournalDate,
            vatTotal: input.receivedTaxInvoice.vatTotal,
            purchaseTaxPeriodDate: input.receivedTaxInvoice.taxPeriod,
          };
          API.PP30Service.DoCreateReceivedTaxInvoice(input, receivedTaxInvoice).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const sourceIdInput = {
                financeType: input.financeType,
                sourceId: input.sourceId,
                sourceType: input.sourceType,
                taxInvoiceDate: input.receivedTaxInvoice.receivedTaxInvoiceDate,
                taxPeriod: input.receivedTaxInvoice.taxPeriod,
                taxInvoiceType: TaxInvoiceType.TaxInvoice,
              };
              this.context.commit("SetReceivedTaxInvoiceData", sourceIdInput);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
            } else {
              const alertMessage = GetMessageExceptionCodeForRealtime(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
              this.context.dispatch("Loading/IsLoading", false, { root: true });
              this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Fail);
            }
          });
        } else {
          this.context.commit("SetDoReceivedTaxInvoiceLoadingStatus", LoadingStatusType.Success);
        }
      });
    }
  }

  @Action
  public DoGetPP30TransactionTableByPeriodTaxForAddNew(input: any) {
    if (this.pp30TransactionTableByPeriodTaxForAddNewLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30TransactionTableByPeriodTaxForAddNewLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30TransactionTableByPeriodTax(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const pp30TransactionTableByPeriodTax = ConvertToPP30TransactionTableByPeriodTax(res.data.data, input.check);
          this.context.commit("SetPP30TransactionTableByPeriodTaxForAddNew", pp30TransactionTableByPeriodTax);
        }
        this.context.commit("SetPP30TransactionTableByPeriodTaxForAddNewLoadingStatus", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoFetchDataPP30Transaction(input: any) {
    const prepareInput = {
      language: i18n.locale,
      financeType: input.financeType,
      fromDate: input.fromDate.ToDateJsonString(),
      toDate: input.toDate.ToDateJsonString(),
      isExceptItemFiled: input.isExceptItemFiled,
    };
    if (this.fetchDataPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoFetchDataPP30Transaction(prepareInput).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.data && res.data.data.length > 0) {
            this.context.commit("SetNumberOfFetchDataPP30", res.data.data.length);
          } else {
            this.context.commit("SetNumberOfFetchDataPP30", 0);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Fetch_Data_Not_Found", {
                  name: i18n.t(
                    input.financeType === FinanceType.InFlow ? "Sales_Tax_Lowercase" : "Purchase_Tax_Lowercase"
                  ),
                }),
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
          this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoFetchDataPP30TransactionByNumber(input: any) {
    if (this.fetchDataPP30TransactionLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.DoFetchDataPP30TransactionByNumber(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (res.data.data && res.data.data.length > 0) {
            this.context.commit("SetTaxInvoiceFetchData", res.data.data);
            this.context.commit("SetNumberOfFetchDataPP30", res.data.data.length);
          } else {
            this.context.commit("SetNumberOfFetchDataPP30", 0);
            this.context.dispatch(
              "Alert/SetAlertMessage",
              {
                alertMessage: i18n.t("Fetch_Data_Not_Found", {
                  name: i18n.t(
                    input.financeType === FinanceType.InFlow ? "Sales_Tax_Lowercase" : "Purchase_Tax_Lowercase"
                  ),
                }),
                typeMessage: TypeComponentNoti.error,
              },
              { root: true }
            );
          }
          this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
          this.context.commit("SetFetchDataPP30TransactionLoadingStatus", LoadingStatusType.Fail);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
      });
    }
  }

  @Action
  public DoInsertPP30Form(pp30FormCreateTemplate: any) {
    if (this.insertPP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetInsertPP30FormLoadingStatusLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      const insertPP30FormModel = ConvertToInsertPP30FormModel(pp30FormCreateTemplate);
      API.PP30Service.InsertPP30Form(insertPP30FormModel).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (pp30FormCreateTemplate.status < PP30FormStatus.AwaitFiling) {
            router.push({
              name: "pp30form",
              query: { emi: MerchantId().PeakEncryption() },
            });
          } else {
            router.push({
              name: "pp30Detail",
              query: { emi: MerchantId().PeakEncryption(), epi: btoa(res.data.data.id.toString()) },
            });
          }
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Created_PP30_Success", { msg: res.data.data.formNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetInsertPP30FormLoadingStatusLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public async GetPP30FormById(pp30FormId: any) {
    if (this.pp30FormDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.Loading);
      const res = await API.PP30Service.GetPP30FormById(pp30FormId);
      if (res.data.responseCode.IsSuccess()) {
        const resPP30Transaction = await API.PP30Service.GetPP30TransactionTableByPP30Id(pp30FormId);
        if (res.data.responseCode.IsSuccess()) {
          const pp30FormDetailModel = ConvertToPP30FormDetailModel(res.data.data, resPP30Transaction.data.data);
          this.context.commit("SetPP30FormDetai", pp30FormDetailModel);
        }
        this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.Success);
      }
    }
  }

  @Action
  public DoUpdatePP30Form(pp30FormCreateTemplate: any) {
    if (this.insertPP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetInsertPP30FormLoadingStatusLoadingStatus", LoadingStatusType.Loading);
      const insertPP30FormModel = ConvertToInsertPP30FormModel(pp30FormCreateTemplate);
      API.PP30Service.UpdatePP30Form(insertPP30FormModel).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          if (pp30FormCreateTemplate.status < PP30FormStatus.AwaitFiling) {
            router.push({
              name: "pp30form",
              query: { emi: MerchantId().PeakEncryption() },
            });
          } else {
            router.push({
              name: "pp30Detail",
              query: { emi: MerchantId().PeakEncryption(), epi: btoa(res.data.data.id.toString()) },
            });
          }
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Updated_PP30_Success", { msg: res.data.data.formNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetInsertPP30FormLoadingStatusLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoVoidPP30Form(pp30Form: any) {
    if (this.voidPP30FormLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidPP30FormLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.VoidPP30Form(pp30Form.id).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          router.push({
            name: "pp30form",
            query: { emi: MerchantId().PeakEncryption(), stid: PP30FormTableViewStatusType.Voided.toString() },
          });
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Voided_PP30_Success", { msg: res.data.data.formNumber }),
              typeMessage: TypeComponentNoti.success,
            },
            { root: true }
          );
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidPP30FormLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public async DoGetIsFiledPP30(input: any) {
    if (this.isFiledPP30ModelFromMongoLoadingStatus !== LoadingStatusType.Loading) {
      const data = {
        pp30Id: input.pp30Id,
      };
      this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.Loading);
      const res = await API.PP30Service.GetIsFiledPP30Model(data);
      if (res.data.responseCode.IsSuccess()) {
        this.context.commit("SetIsFiledPP30ModelFromMongoDetail", res.data.data);
        this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.Success);
      }
    }
  }

  @Action
  public DoUpdateIsFiledPP30(input: any) {
    if (this.updateIsFiledPP30LoadingStatus !== LoadingStatusType.Loading) {
      const pp30UpdateIsFiledOption = ConvertToUpdateIsFiledPP30(input, "");
      this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsFiledByPP30Id(pp30UpdateIsFiledOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Filing_Tax_Form_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateIsFiledPP30ByPrintForm(input: any) {
    if (this.updateIsFiledPP30LoadingStatus !== LoadingStatusType.Loading) {
      const url = `${
        process.env.VUE_APP_PeakDocument
      }pp30?emi=${MerchantId().PeakEncryption()}&eti=${input.pp30Id.PeakEncryption()}&etti=${TransactionType.PP30.PeakEncryption()}`;

      window.open(url);

      const pp30UpdateIsFiledOption = ConvertToUpdateIsFiledPP30(input, url);
      this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsFiledByPP30Id(pp30UpdateIsFiledOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Filing_Tax_Form_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoVoidIsFiledPP30(input: any) {
    if (this.updateIsFiledPP30LoadingStatus !== LoadingStatusType.Loading) {
      const pp30UpdateIsFiledOption = ConvertToUpdateIsFiledPP30(input, "");
      this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsFiledByPP30Id(pp30UpdateIsFiledOption).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Cancel_Filed_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetUpdateIsFiledPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateIsPaidPP30(input: any) {
    if (this.updateIsPaidPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateIsPaidPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsPaidByPP30Id(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: input.isPaid
                ? i18n.t("Payment_Tax_Success", { msg: input.formNumber })
                : i18n.t("Cancel_Payment_Tax_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );

          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }

        this.context.commit("SetUpdateIsPaidPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoUpdateIsClosingEntryPP30(input: any) {
    if (this.updateIsClosingEntryPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetUpdateIsClosingEntryPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.UpdateIsClosingEntryPP30(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Record_Closing_Tax_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        }
        this.context.commit("SetUpdateIsClosingEntryPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoCreateExpenseByIsClosingEntryPP30(input: any) {
    if (this.createExpenseByIsClosingEntryPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCreateExpenseByIsClosingEntryPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.CreateExpenseByIsClosingEntryPP30(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Record_Payment_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetCreateExpenseByIsClosingEntryPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoCreateExpenseByIsClosingEntryPP30NewTimeline(input: any) {
    if (this.createExpenseByIsClosingEntryPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetCreateExpenseByIsClosingEntryPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.CreateExpenseByIsClosingEntryPP30NewTimeline(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Record_Payment_Success", { msg: input.formNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
        this.context.commit("SetCreateExpenseByIsClosingEntryPP30LoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public async DoGetClosingEntryPP30ModelFromMongo(input: any) {
    if (this.closingEntryPP30ModelFromMongoLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.Loading);
      try {
        const res = await API.PP30Service.GetClosingEntryPP30ModelFromMongo(input);
        if (res.data.responseCode.IsSuccess()) {
          const closingEntryPP30ModelFromMongo = ConvertToClosingEntryPP30ModelFromMongo(res.data.data);
          this.context.commit("SetClosingEntryPP30ModelFromMongo", closingEntryPP30ModelFromMongo);
        }
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.Success);
      } catch (error) {
        this.context.dispatch("Loading/IsLoading", false, { root: true });
        this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.Success);
      }
    }
  }

  @Action
  public async DoGetPeakTaxInvoiceList(input: any) {
    if (this.taxInvoiceDetailListForTaxPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTaxInvoiceDetailListForTaxPP30LoadingStatus", LoadingStatusType.Loading);
      const resDataList: any = [];
      const maxSliceArray = 1000;
      const idSliceList = SliceArrayData(input, maxSliceArray);
      for (let count = 0; count < idSliceList.length; count++) {
        await new Promise((resolve) => setTimeout(resolve, 100));
        await API.PP30Service.GetPeakTaxInvoiceList(idSliceList[count]).then((res) => {
          if (res.data.responseCode.IsSuccess()) {
            const _taxInvoiceList = res.data.data;
            if (_taxInvoiceList && _taxInvoiceList.length > 0) {
              _taxInvoiceList.forEach((_taxInvoiceItem: any) => {
                const data = ConvertToTaxInvoiceDetailData(_taxInvoiceItem);
                resDataList.push(data);
              });
            }
          }
        });
      }
      this.context.commit("SetTaxInvoiceDetailListForTaxPP30", resDataList);
      this.context.commit("SetTaxInvoiceDetailListForTaxPP30LoadingStatus", LoadingStatusType.Success);
    }
  }

  @Action
  public DoGetPeakTaxInvoiceListForUpdatePP30Transaction(input: any) {
    if (this.taxInvoiceDetailForUpdateTaxPP30LoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetTaxInvoiceDetailForUpdateTaxPP30LoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPeakTaxInvoiceList(input.idList).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const taxInvoiceList = ConvertToTaxInvoiceDetailListForTaxPP30(res.data.data);
          this.context.commit("SetTaxInvoiceDetailForUpdateTaxPP30", taxInvoiceList[0]);
          if (this.pp30TransactionLoadingStatus !== LoadingStatusType.Loading) {
            this.context.dispatch("Loading/IsLoading", true, { root: true });
            API.PP30Service.GetPP30Transaction(input.transactionId).then((res) => {
              if (res.data.responseCode.IsSuccess()) {
                const pp30TransactionTemplate = ConvertToPP30TransactionModel(res.data.data);
                this.context.commit("SetGetPP30Transaction", pp30TransactionTemplate);
              }
              this.context.commit("SetTaxInvoiceDetailForUpdateTaxPP30LoadingStatus", LoadingStatusType.Success);
              this.context.dispatch("Loading/IsLoading", false, { root: true });
            });
          }
        }
      });
    }
  }

  @Action
  public DoGetPP30FormByLastDateTime() {
    if (this.pp30FormByLastDateTimeLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetPP30FormByLastDateTimeLoadingStatus", LoadingStatusType.Loading);
      API.PP30Service.GetPP30FormByLastDateTime().then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.commit("SetPP30FormByLastDateTimeList", res.data.data);
        }
        this.context.commit("SetPP30FormByLastDateTimeLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoVoidIsClosingEntryPP30Journal(input: any) {
    if (this.voidIsClosingEntryPP30JournalLoadingStatusType !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidIsClosingEntryPP30JournalLoadingStatusType", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PP30Service.VoidIsClosingEntryPP30Journal(input.data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Void_Record_Account_Success", { number: input.journalNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidIsClosingEntryPP30JournalLoadingStatusType", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
  @Action
  public DoVoidFileMarkReceiptPP30Form(input: any) {
    if (this.voidFileMarkReceiptLoadingStatusType !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidFileMarkReceiptLoadingStatusType", LoadingStatusType.Loading);
      switch (input.taxDocumentType) {
        case TaxDocumentType.PP30Form: {
          API.PP30Service.VoidFileMarkReceiptPP30Form(input.file).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: i18n.t("Void_Mark_Receipt_Success"),
                  typeMessage: TypeComponentNoti.Success,
                },
                { root: true }
              );
              this.context.commit("SetPP30FormDetailLoadingStatus", LoadingStatusType.None);
              this.context.commit("SetIsFiledPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
            } else {
              const alertMessage = GetMessageExceptionCode(res.data.exception);
              this.context.dispatch(
                "Alert/SetAlertMessage",
                {
                  alertMessage: alertMessage,
                  typeMessage: TypeComponentNoti.Error,
                },
                { root: true }
              );
            }
            this.context.commit("SetVoidFileMarkReceiptLoadingStatusType", LoadingStatusType.Success);
          });
          break;
        }
      }
    }
  }
  @Action
  public DoVoidIsClosingEntryPP30Expense(input: any) {
    if (this.voidIsClosingEntryPP30ExpenseLoadingStatusType !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidIsClosingEntryPP30ExpenseLoadingStatusType", LoadingStatusType.Loading);
      API.PP30Service.VoidIsClosingEntryPP30Expense(input.data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Void_Record_Payment_Tax_Success", { number: input.expenseNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
        }
        this.context.commit("SetVoidIsClosingEntryPP30ExpenseLoadingStatusType", LoadingStatusType.Success);
      });
    }
  }
  @Action
  public DoVoidPP30ExpenseNewTimeline(input: any) {
    if (this.voidIsClosingEntryPP30ExpenseLoadingStatusType !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidIsClosingEntryPP30ExpenseLoadingStatusType", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      API.PP30Service.VoidPP30ExpenseNewTimeline(input.data).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: i18n.t("Void_Record_Payment_Tax_Success", { number: input.expenseNumber }),
              typeMessage: TypeComponentNoti.Success,
            },
            { root: true }
          );
          this.context.commit("SetClosingEntryPP30ModelFromMongoLoadingStatus", LoadingStatusType.None);
        } else {
          const alertMessage = GetMessageExceptionCode(res.data.exception);
          this.context.dispatch(
            "Alert/SetAlertMessage",
            {
              alertMessage: alertMessage,
              typeMessage: TypeComponentNoti.Error,
            },
            { root: true }
          );
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        }
        this.context.commit("SetVoidIsClosingEntryPP30ExpenseLoadingStatusType", LoadingStatusType.Success);
      });
    }
  }
}
